import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { App } from './App'
import { cargarConfig, esCaja } from './lib/config'
import { ErrorApi } from './lib/api'
import './index.css'

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // De fábrica NADA se da por fresco, así que entrar a una pantalla vuelve
      // a preguntar.
      //
      // Había un minuto global, puesto con el argumento del catálogo y de la
      // configuración —que casi no cambian en una jornada— y aplicado a TODO:
      // el listado de ventas, el control de caja, la merma, las compras, el
      // fiado y la bitácora quedaban congelados hasta un minuto. O sea que el
      // dueño abría Control de caja justo después de que el mostrador cobró y
      // no veía la venta, y la única salida era recargar la página con F5.
      // Un sistema que hay que recargar para creerle es un sistema al que se
      // le deja de creer.
      //
      // Es la misma regla que ya está escrita para el `NoTracking` de EF: el
      // default tiene que ser el CORRECTO y la optimización tiene que ser la
      // EXPLÍCITA. Y no hay nada que recuperar, porque las consultas que de
      // verdad necesitan caché ya declaran su propio `staleTime` —el catálogo
      // del POS y sus opciones (5 min), el tablero (1 min), los lookups
      // (30 s), y la ayuda, el menú, los módulos y los roles (Infinity)—.
      //
      // Y no parpadea: react-query devuelve lo que tiene en caché al instante
      // y consulta atrás, así que la grilla no se vacía mientras responde.
      staleTime: 0,

      // Volver a la pestaña SÍ es una señal de refresco, y en el navegador es
      // la que faltaba: dejar Ventas abierta, cobrar en el mostrador y volver
      // no remonta nada, así que sin esto la pantalla seguía vieja aunque el
      // default de arriba estuviera bien.
      //
      // En el ejecutable del mostrador no: esa ventana está siempre abierta y
      // el foco va y viene cada vez que el cajero atiende el cajón, así que
      // ahí serían consultas por nada. Va como FUNCIÓN porque se evalúa al
      // momento de refrescar: este cliente se arma antes de que se cargue el
      // config.json, así que un `esCaja()` suelto acá todavía no sabe en qué
      // runtime está.
      refetchOnWindowFocus: () => !esCaja(),

      retry: (intentos, error) => {
        // No reintentar lo que no va a mejorar: un 403 o un 404 van a fallar
        // igual las tres veces, y el reintento solo demora el mensaje.
        if (error instanceof ErrorApi && error.status < 500 && error.status !== 0) return false
        return intentos < 2
      },
    },
    mutations: {
      // Las mutaciones NUNCA se reintentan solas: reintentar un cobro o una
      // anulación puede duplicar la operación.
      retry: false,
    },
  },
})

// La configuración del runtime se lee ANTES de montar: la URL de la API y las
// capacidades de hardware se necesitan desde el primer request, y montar
// primero significaría un parpadeo con la configuración equivocada.
void cargarConfig().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={cliente}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  )
})
